import {
    Autoplay,
    Controller,
    EffectCreative,
    EffectFade,
    FreeMode,
    Mousewheel,
    Navigation,
    Pagination,
    Thumbs
} from 'swiper/modules';
import type {ISwiperSlider, ISwiperSliderOptions} from '@/components/swiper-slider/types';
import Swiper from 'swiper';

class SwiperSlider implements ISwiperSlider {
    private readonly item: HTMLElement | null;
    private readonly settings: Record<string, any>;
    private slider: Swiper | null;

    constructor(options: ISwiperSliderOptions) {
        this.item = options.item;
        this.slider = null;

        this.settings = {
            modules: options.modules ||
            [Controller, EffectCreative, EffectFade, Navigation, Pagination, Thumbs, Autoplay, Mousewheel, FreeMode],
            ...options.settings
        };
    }

    public get getSlider(): Swiper | null {
        return this.slider;
    }

    init(): void {
        if (!this.item) {
            return;
        }

        this.slider = new Swiper(this.item, this.settings);
    }

    destroy(): void {
        if (!this.slider) {
            return;
        }

        this.slider.destroy();
        this.slider = null;
    }
}

export default SwiperSlider;
